import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { APP_TEXT_EN, APP_TEXT_ES, Language } from '../constants/app.constants';
import { newCampaignQuestion, newEventItem, newValidateCodeResponse, newValidateCodeResult, oldCampaignQuestion, oldEventItem, oldValidateCodeResponse } from '../model/common.model';

declare global {
  interface Window { dataLayer: any[]; }
}

@Injectable({
  providedIn: 'root'
})

export class GlobalService {

  constructor() {
    window.dataLayer = window.dataLayer || [];
  }


  pushEvent(event: any) {
    if (typeof window.dataLayer !== 'undefined' && window.dataLayer) {
      window.dataLayer.push(event);
    }
  }

  public adaptNewToOldEvent(newEvent: newEventItem): oldEventItem {
    const event = {
      EventId: newEvent.eventId,
      EventDateTime: newEvent.eventDateTime,
      TimeZone: newEvent.timeZone,
      Name: newEvent.name,
      Address: {
        AddressLine1: newEvent.address.addressLine1,
        AddressLine2: newEvent.address.addressLine2,
        City: newEvent.address.city,
        State: newEvent.address.state,
        Zip: newEvent.address.zip
      },
      MaxCapacity: newEvent.maxCapacity,
      MaxPerParty: newEvent.maxPerParty,
      CurrentReservationCount: newEvent.currentReservationCount,
      IsWaitListOnly: newEvent.isWaitListOnly,
      WaitlistAllowed: newEvent.waitListAllowed,
      AllowGuests: newEvent.allowGuests,
      EventType: newEvent.eventType,
      HasMenu: newEvent.hasMenu,
      MenuItems: newEvent.menuItems
    }
    return event;
  }

  public adaptNewToOldQA(newQA: newCampaignQuestion): oldCampaignQuestion {

    const QA =
    newQA?.campaignQuestionAnswers === null
      ? null
      : newQA.campaignQuestionAnswers.map(item => ({
        Answer: item.answer,
        CampaignQuestionAnswerId: item.campaignQuestionAnswerId,
        CampaignQuestionId: item.campaignQuestionId,
        QualificationOption: item.qualificationOption
      }));

    return {
      CampaignQuestionAnswers: QA,
      CampaignQuestionId: newQA.campaignQuestionId,
      CampaignQuestionType: newQA.campaignQuestionType,
      QuestionText: newQA.questionText,
      SortOrder: newQA.sortOrder
    }
  }

  public adaptNewToOldJobDetail(newJobDetail: newValidateCodeResult): oldValidateCodeResponse {
    const newObj = newJobDetail;
    
    const ResponderFieldRequirements =
      newObj?.responderFieldRequirements === null
        ? null
        : newObj.responderFieldRequirements.map(req => ({
          ResponderFieldName: req.responderFieldName,
          IsRequested: req.isRequested,
          IsRequired: req.isRequired
        }));

    const AppointmentTypes =
      newObj.appointmentTypes === null
        ? null
        : newObj.appointmentTypes.map(req => ({
          AcuityAppointmentTypeId: Number(req.acuityAppointmentTypeId),
          Name: req.name,
          Duration: req.duration,
          ConsumerEmailRequired: req.consumerEmailRequired,
          ConsumerPhoneRequired: req.ConsumerPhoneRequired,
          ConsumerAddressRequired: req.consumerAddressRequired,
        }));

    return {

      ReturnObject: {
        ValidateCodeErrorId: newObj.validateCodeErrorId,
        CampaignId: newObj.campaignId,
        ResponderFieldRequirements: ResponderFieldRequirements,
        SeminarsAvailable: newObj.seminarsAvailable,
        MinSeminarBookingDate: newObj.minSeminarBookingDate,
        MaxSeminarBookingDate: newObj.maxSeminarBookingDate,
        AppointmentsAvailable: newObj.appointmentsAvailable,
        MinAppointmentBookingDate: newObj.minAppointmentBookingDate,
        MaxAppointmentBookingDate: newObj.maxAppointmentBookingDate,
        Calendars: newObj.calendars,
        AppointmentTypes: AppointmentTypes,
        OverbookingAllowed: newObj.overbookingAllowed,
        MailListOnly: newObj.mailListOnly,
        SurveyRequired: newObj.surveyRequired,
        CampaignInfo: {
          EventTitle: newObj.campaignInfo.eventTitle,
          EventText: newObj.campaignInfo.eventText,
          ValuePoints: newObj.campaignInfo.valuePoints,
          Speaker: newObj.campaignInfo.speaker,
          SpeakerTitle: newObj.campaignInfo.speakerTitle,
          SpeakerInformation: newObj.campaignInfo.speakerInformation,
          Disclaimer: newObj.campaignInfo.disclaimer,
          BackgroundStyle: newObj.campaignInfo.backgroundStyle,
          TextMessageEnabled: newObj.campaignInfo.textMessageEnabled,
          ClientTextMessageEnabled: newObj.campaignInfo.clientTextMessageEnabled,
          DisqualificationResponse: newObj.campaignInfo.disqualificationResponse,
          GuestDisqualificationResponse: newObj.campaignInfo.guestDisqualificationResponse,
          CampaignId: newObj.campaignInfo.campaignId,
          BusinessDivisionId: newObj.campaignInfo.businessDivisionId,
          CampaignMessage1: newObj.campaignInfo.campaignMessage1,
          CampaignMessage2: newObj.campaignInfo.campaignMessage2,
          PreSurveyStatement: newObj.campaignInfo.preSurveyStatement,
          CallTransition: newObj.campaignInfo.callTransition,
          CallEnding: newObj.campaignInfo.callEnding
        }
      }
    }
  }
  
  public jobInformation = new BehaviorSubject<any>({
    dataInitialized: false,
    jobNumber: '',
    jobInfo: {},
    // pageData: {
    //   jobNumber: '418321',
    //   jobType: "",
	  //   leadType: "",
	  //   pageTheme: "",
	  //   giftCardAmount: "",
    //   sectionHeader: {
    //     title: "",
    //     subtitle: "",
    //     preTitle: "",
    //     logoImageURL: "https://rsvp.org/custom-images/logos/logo-afea.png",
    //     // logoImageURL: "",
    //     heroImageURL: "",
    //     phoneNumber: "",
    //     ctaButtonSelectEvent: "",
    //     ctaButtonMakeAppointment: "",
    //     ctaTextMakeAppointment: ""
    //   },
    //   sectionEvents: {
    //     title: "",
    //     content: "",
    //     interestedInFutureAppointment: "false",
    //     appointmentOnly: "false",
    //     onDemandWebinar: "false",
    //     ctaButtonMakeAppointment: "",
    //     ctaTextMakeAppointment: "",
    //     imageBelowURL: ""
    //   },
    //   sectionContent: {
    //     title: "",
    //     content: "",
    //     imageMainURL: "",
    //     imageBelowURL: "",
    //     ctaButtonSelectEvent: "",
    //     hideSection: "false"
    //   },
    //   sectionSpeakers: {
    //     title: "",
    //     speakers: [
    //       {
    //         name: "",
    //         title: "",
    //         headshotURL: "",
    //         bio: "",
    //         note: ""
    //       },
    //       {
    //         name: "",
    //         title: "",
    //         headshotURL: "",
    //         bio: "",
    //         note: ""
    //       }
    //     ],
    //     imageBelowURL: "",
    //     ctaButtonSelectEvent: "",
    //     hideSection: "false",
    //     roundedHeadshots: "false"
    //   },
    //   disclaimers: {
    //     formDisclaimer: "",
    //     footerDisclaimer: "Test footer Disclaimer",
    //     confirmationDisclaimer: "",
    //     notice: {
    //       content: "",
    //       severity: "1",
    //       location: "confirmation"
    //     }
    //   },
    //   video: {
    //     videoID: "",
    //     location: "Below Events",
    //   }
    // },
  });

  public registrationInformation = new BehaviorSubject<any>({
    eventID: '',
    responderData: {},
    guestData: {}
  });

  private _Language:any;
  private _appLanguage!:Language;
  private _eventCount:number = 0;
  private _ip:any;
  private _multiEvent:boolean = false;

  set multiEvent(flag: boolean) {
    this._multiEvent = flag;
  }

  get multiEvent(): boolean {
    return this._multiEvent;
  }

  set ip(sysIp:any){
    this._ip = sysIp;
  }

  get ip(){
    return this._ip
  }

  set Language(lang: Language) {
    this._Language = (lang == Language.Spanish) ? APP_TEXT_ES : APP_TEXT_EN;
    this._appLanguage = lang;
  }

  
  get Language(): any {
    return this._Language  || APP_TEXT_EN;
  }

  get AppLanguage(): any {
    return this._appLanguage  || Language.English;
  }

  set eventCount(count:number){
    this._eventCount = count;
  }
  get eventCount():number{
    return this._eventCount;
  }

}
export interface IRegisterRequest{
  campaignId:number,
  code:string,
  firstName:string,
  lastName:string,
  addressLine1:string,
  addressLine2:string,
  city:string | undefined,
  state:string | undefined,
  zip:string,
  phone:string,
  email:string,
  phoneType:string,
  audience_Key:number
}

export interface IEventRegisterReq {
  responderId: number,
  eventIds: any[],

  addQuestionAnswers_Qualifying: {
    responderQuestionAnswers: ResponderQuestionAnswer[];
  };

  addReservation: {
    campaignId: number;
    isWaitlist: boolean;
    menuSelection: string;
    language: string;
    PhoneOptIn: boolean | null;
    EmailOptIn: boolean | null;
    TextOptIn: boolean;
  };

  addQuestionAnswers_Survey: {
    responderQuestionAnswers: ResponderQuestionAnswer[];
  };
  addGuestList: Guest[];
}


export interface ResponderQuestionAnswer {
  campaignQuestionId: number;
  campaignQuestionAnswerId: number;
  answerText: string;
}

export interface Guest {
  firstName: string;
  lastName: string;
  relationshipTypeId: number;
  menuSelection: string;
}
